import { Box, styled } from "@mui/material";
import { Layer } from "types/types";
import { LayerSetDialogTag } from "./LayerSetDialogTag";
import { LayerSetSelect } from "./LayerSetSelect";

interface Props {
  layerList: Layer[];
}

export function LayerSetDialogTags(props: Props) {
  const { layerList } = props;

  return (
    <StyledBox>
      {layerList.length > 6 && <LayerSetSelect layerList={layerList} />}
      {layerList.length <= 6 &&
        layerList.map((layer) => (
          <LayerSetDialogTag
            key={layer.id}
            layer={layer}
            layerList={layerList}
          />
        ))}
    </StyledBox>
  );
}

const StyledBox = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(1)};
  flex-wrap: wrap;  
`;
